// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Z6DWc","choiceBoxes":"toolbarselects_choiceBoxes__3qM4w","simpleField":"toolbarselects_simpleField__1p4xo"};